export const baseURL = "http://localhost:3025";

// This deployment serves a single institute; its code is passed to every
// public (unauthenticated) /student endpoint so the backend can resolve it.
export const INSTITUTE_CODE = "main";

export const LOGIN = "admin/login_admin";

export const ALLSTD = "admin/all_students";
export const STD = "admin/add_student";
export const ALL_CLASSES = `/student/classes?institute_code=${INSTITUTE_CODE}`;
export const SUBJECTS = "/admin/all_subjects";
export const SUBJECTS_BY_CLASS = (classId) => `/admin/subjects/${classId}`;
export const STUDENT_SUBJECTS = (classId) => `/student/subjects/${classId}?institute_code=${INSTITUTE_CODE}`;
export const ALL_INTENSIVE = `/student/intensive?institute_code=${INSTITUTE_CODE}`;
export const SUBJECT = "/admin/add_new_subject";

// Legacy (kept for AddLesson / Lesson edit pages — not yet migrated)
export const PRODUCTS = "products";
export const PRODUCT  = "product";

// Subjects (per-subject CRUD — distinct from the add endpoint)
export const ADMIN_ALL_SUBJECTS   = "/admin/all_subjects";
export const ADMIN_SUBJECT_BY_ID  = (id) => `/admin/subject/${id}`;

// Lectures (lessons)
export const ADMIN_ALL_LECTURES = "/admin/all_lectures";
export const ADMIN_ADD_LECTURE  = "/admin/add_lecture";
export const ADMIN_LECTURE      = (id) => `/admin/lecture/${id}`;
export const ADMIN_LECTURE_FILE = (filename) => `/admin/file/lecture/${filename}`;

// Classes (admin CRUD)
export const ADMIN_ALL_CLASSES = "/admin/get_all_classes";
export const ADMIN_ADD_CLASS    = "/admin/add_new_class";
export const ADMIN_UPDATE_CLASS = (id) => `/admin/class/${id}`;
export const ADMIN_DELETE_CLASS = (id) => `/admin/class/${id}`;

// Students (admin CRUD)
export const ADMIN_GET_STUDENT    = (id) => `/admin/one_student/${id}`;
export const ADMIN_UPDATE_STUDENT = (id) => `/admin/student/${id}`;

// Intensive courses (admin)
export const ADMIN_ALL_INTENSIVE    = `/admin/all_intensive?institute_code=${INSTITUTE_CODE}`;
export const ADMIN_NEW_INTENSIVE    = "/admin/new_intensive";
export const ADMIN_UPDATE_INTENSIVE = "/admin/update_intensive";
export const ADMIN_DELETE_INTENSIVE = "/admin/delete_intensive";
export const ADMIN_ONE_INTENSIVE    = (id) => `/admin/one_intensive/${id}?institute_code=${INSTITUTE_CODE}`;

// Intensive course lecture materials (admin)
export const ADMIN_ADD_LECTURE_INTENSIVE     = "/admin/add_lecture_intensive";
export const ADMIN_LECTURES_BY_INTENSIVE     = (intensiveId) => `/admin/lectures_intensive/intensive/${intensiveId}`;
export const ADMIN_LECTURE_INTENSIVE_BY_ID   = (id) => `/admin/lectures_intensive/${id}`;
export const ADMIN_LECTURE_INTENSIVE_FILE    = (filename) => `/admin/file/lecture_intensive/${filename}`;

// Intensive course enrollment (admin)
export const ADMIN_ENROLL_INTENSIVE       = "/admin/enrollment_intensive";
export const ADMIN_UNENROLL_INTENSIVE     = "/admin/unenroll_intensive";
export const ADMIN_INTENSIVE_STUDENTS     = (intensiveId) => `/admin/intensive/${intensiveId}/enrolled_students`;

// Gallery
export const ADMIN_GALLERY          = "/admin/gallery";
export const ADMIN_GALLERY_BY_ID    = (id) => `/admin/gallery/${id}`;
export const ADMIN_GALLERY_SETTINGS = "/admin/gallery/settings";
export const ADMIN_GALLERY_REORDER  = "/admin/gallery/reorder";
export const PUBLIC_GALLERY         = `/student/gallery?institute_code=${INSTITUTE_CODE}`;
export const GALLERY_PHOTO_URL      = (filename) => `${baseURL}/uploads/gallery/${filename}`;

// Admin management (superadmin only)
export const ADMIN_ALL_ADMINS  = "/admin/admins";
export const ADMIN_ADD_ADMIN   = "/admin/add_admin";
export const ADMIN_DELETE_ADMIN = (id) => `/admin/admin/${id}`;

// Excellent students
export const ADMIN_ALL_EXCELLENT    = `/admin/excellent_students?institute_code=${INSTITUTE_CODE}`;
export const ADMIN_ADD_EXCELLENT    = "/admin/excellent_student";
export const ADMIN_REMOVE_EXCELLENT = (id) => `/admin/excellent_student/${id}`;
export const PUBLIC_EXCELLENT_STUDENTS = `/student/excellent_students?institute_code=${INSTITUTE_CODE}`;

// Notifications
export const ADMIN_ALL_NOTIFICATIONS    = "/admin/all_notifications";
export const ADMIN_SEND_NOTIFICATION    = "/admin/send_notification";
export const ADMIN_DELETE_NOTIFICATION  = (id) => `/admin/notification/${id}`;
